/**
 * Permissões: módulo × acção, herdado do RBAC da Ribeiro (sem "gerir" — uma
 * verificação contra uma acção que não existe só passaria para o dono).
 * Cada papel tem uma matriz; `memberships.permissions` guarda excepções.
 */
/** cash = caixa e bancos: view consulta saldos e movimentos; create faz o fecho de caixa; edit regista movimentos manuais, transferências e configura as contas. */
export const MODULES = ['documents', 'customers', 'products', 'stock', 'purchases', 'accounts', 'reports', 'exports', 'settings', 'users', 'audit', 'billing', 'cash'];
export const ACTIONS = ['view', 'create', 'edit', 'delete', 'issue', 'send', 'export', 'void'];
export const ROLES = ['owner', 'admin', 'accountant', 'seller', 'viewer'];
export const ROLE_LABELS = {
    owner: 'Dono', admin: 'Administrador', accountant: 'Contabilista', seller: 'Vendedor', viewer: 'Consulta',
};
const all = (m) => ACTIONS.map((a) => `${m}:${a}`);
const MATRIX = {
    owner: MODULES.flatMap(all),
    admin: MODULES.filter((m) => m !== 'billing').flatMap(all),
    accountant: [
        'documents:view', 'customers:view', 'products:view', 'stock:view', 'purchases:view', 'accounts:view',
        'reports:view', 'reports:export', 'exports:view', 'exports:export', 'audit:view', 'cash:view', 'cash:export',
    ],
    seller: [
        'documents:view', 'documents:create', 'documents:edit', 'documents:delete', 'documents:issue', 'documents:send',
        'customers:view', 'customers:create', 'customers:edit', 'products:view', 'stock:view', 'accounts:view',
        'cash:view', 'cash:create',
    ],
    viewer: ['documents:view', 'customers:view', 'products:view', 'stock:view', 'accounts:view', 'reports:view', 'cash:view'],
};
export function permissionsFor(role, overrides = {}) {
    const set = new Set(MATRIX[role]);
    for (const [p, allow] of Object.entries(overrides)) {
        if (allow)
            set.add(p);
        else
            set.delete(p);
    }
    return set;
}
//# sourceMappingURL=permissions.js.map